import { cloneElement } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";
import { useTranslations } from "contexts/LocalizationContext/hooks";

const { AccordionItem, AccordionButton, Box, AccordionIcon, AccordionPanel, Accordion: ChakraAccordion } = Chakra;

const Accordion = ({ items, icons: { close, open }, ...props }) => {
  const translations = useTranslations();

  const accordionItems =
    items &&
    items.map((item) => (
      <AccordionItem key={item.header} boxShadow="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton>
              <Box flex="1" textAlign="left" fontWeight="bold">
                {translations(item.header)}
              </Box>
              {isExpanded ? close : open}
            </AccordionButton>
            <AccordionPanel listStylePosition="inside">
              {item.content.map((el) => cloneElement(el, { key: el.props.content }))}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    ));

  return (
    <ChakraAccordion allowToggle {...props}>
      {accordionItems}
    </ChakraAccordion>
  );
};

export default Accordion;

Accordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: PropTypes.arrayOf(PropTypes.node),
    })
  ).isRequired,
  icons: PropTypes.objectOf(PropTypes.element),
};

Accordion.defaultProps = {
  icons: { close: <AccordionIcon color="primary.500" />, open: <AccordionIcon color="primary.500" /> },
};
